import { useGetAlumniQuery } from "../../features/api/appApi";

const AlumniSection = () => {
  const { data: alumni = [] } = useGetAlumniQuery();

  return (
    <section className="home-section">
      <div className="home-container">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="section-kicker">Alumni</span>
            <h2 className="home-title mt-4 text-2xl font-bold sm:text-4xl">
              Community alumni who continue to <span className="home-accent-gradient">inspire members</span>
            </h2>
          </div>
          <p className="max-w-md text-sm home-muted">
            Their journey reflects the long-term impact of consistent practice and collaboration.
          </p>
        </div>

        {alumni.length === 0 ? (
          <div className="home-card p-8 text-center text-sm home-muted">No alumni available right now.</div>
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            {alumni.map((member) => (
              <article key={member.id} className="home-card group overflow-hidden">
                <div className="overflow-hidden">
                  <img src={member.imageUrl} alt={member.name} className="h-44 w-full object-cover transition-transform duration-300 group-hover:scale-105" />
                </div>
                <div className="p-3 text-center">
                  <p className="text-xs font-semibold sm:text-sm">{member.name}</p>
                  <p className="mt-1 text-[11px] home-muted">{member.designation || ""}</p>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default AlumniSection;
